// extracted by mini-css-extract-plugin
export default {"panelContainer":"GenericExpandablePanel_panelContainer__Z8-ci"};